import { useContext, useState } from 'react';

import Axios from 'axios';

import { Button, Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import DashboardContext from '../../Context';

import style from './ModalDelete.module.css'
/**
 * این کامپوننت برای مدال پرداخت است
 */
const ModalPaid = ({ showitem, handleCloseMoudal, id, handeldeleteModal, urldata, handelModalepaid }) => {

    const { location } = useHistory()

    const { urldashboard, authentication } = useContext(DashboardContext);

    const [loading, setLoading] = useState(false)

    const [dataDelete, setDataDelete] = useState({})


    const handelDelete = async () => {
        setLoading(true)
        try {
            const res = await Axios.put(`${urldashboard}${urldata ? urldata : location.pathname}/paid`, JSON.stringify({ paymentReceiptIds: [`${id}`] }), {
                headers: {
                    "Authorization": authentication,
                    "content-type": "application/json; charset=utf-8"
                }
            })

            const data = await res.data

            setDataDelete(data)
            setLoading(false)
            handeldeleteModal()
            handelModalepaid()
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } catch (error) {
            //console.log(error);
            if (error.message === 'Network Error') {
                setDataDelete({ status: 500, message: 'اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(' })
                setLoading(false)
            }
            else {
                setDataDelete(error.response.data)
                setLoading(false)
            }
        }
    }

    return (
        <Modal show={showitem} onHide={handleCloseMoudal}>
            <Modal.Header className={style.Header}>
                <Modal.Title >پرداخت مورد انتخابی</Modal.Title>
                <i className="fa fa-times mr-auto" style={{fontSize:'16px',cursor:'pointer'}} onClick={handleCloseMoudal}  aria-hidden="true"></i>

            </Modal.Header>
            <Modal.Body className={style.body} >
                <i className="mdi mdi-alert-circle-outline"></i>
                {
                    loading ?
                        "درحال پرداخت منتظر باشید..."
                        :
                        dataDelete.hasOwnProperty("status") ?
                            dataDelete.message
                            :
                            "آیا از پرداخت مطمئن هستید؟"
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" disabled={loading} onClick={handleCloseMoudal}>
                    خیر
          </Button>
                <Button variant="success" disabled={loading} onClick={handelDelete}>
                    {
                        loading ?
                            <i className="fa fa-spinner fa-pulse fa-fw"></i>

                            : "بله"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalPaid;
